<div (keydown.enter)="$event.preventDefault()" class="tw-my-auto md:tw-pt-16">
  <modal-header
    id="locationSelectionTitle"
    [title]="'locationSelection' | i18n"
    [showBackButton]="false"
    [showCloseButton]="false"
  ></modal-header>

  <div
    class="modal-body tw-w-full md:tw-w-screen md:tw-min-h-screen md:tw-max-h-none md:tw-max-w-none tw-h-auto tw-max-w-[560px] tw-mx-auto md:tw-flex md:tw-flex-col md:tw-justify-start md:tw-pt-6"
  >
    <div class="tw-flex tw-gap-6 tw-flex-col">
      <ng-container *ngFor="let loc of locations">
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-between tw-w-full tw-rounded-xl tw-bg-dt-surface-elevated tw-p-5 tw-text-left"
          (click)="userLocationService.processUserLocation(loc.code)"
        >
          <span class="tw-text-base tw-font-medium">{{ loc.labelKey | i18n }}</span>
          <span class="tw-flex tw-items-center tw-justify-end tw-pr-16 md:tw-pr-0">
            <bank-icons
              [banks]="userLocationService.getBanks(loc.code)"
              [iconName]="iconName"
              [svgClass]="iconSvgClass"
            ></bank-icons>
          </span>
        </button>
      </ng-container>

      <div class="tw-flex tw-w-full tw-items-center">
        <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>
        <p class="tw-text-[14px] tw-text-neutral-300 tw-text-center tw-px-2">
          {{ "locationChangeInfo" | i18n }}
        </p>
        <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>
      </div>

      <div class="tw-px-1">
        <div
          class="tw-bg-dt-information-100 tw-border tw-border-dt-information-300 tw-rounded-3xl tw-p-3 tw-flex tw-items-start tw-gap-3"
        >
          <icon [name]="'info-tooltip'" [size]="7" [currentColor]="'dt-information-500'"></icon>
          <!-- Content -->
          <div class="tw-flex tw-flex-col tw-gap-1">
            <div class="tw-text-[14px] tw-font-medium tw-text-dt-information-500">
              {{ "locationSelectionDesc" | i18n }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
